/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The UploadMonitor model module.
 * @module model/UploadMonitor
 * @version v0
 */
export default class UploadMonitor {
  /**
   * Constructs a new <code>UploadMonitor</code>.
   * @alias module:model/UploadMonitor
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>UploadMonitor</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UploadMonitor} obj Optional instance to populate.
   * @return {module:model/UploadMonitor} The populated <code>UploadMonitor</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UploadMonitor();
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
      if (data.hasOwnProperty('available'))
        obj.available = ApiClient.convertToType(data['available'], 'Boolean');
      if (data.hasOwnProperty('currentStep'))
        obj.currentStep = ApiClient.convertToType(data['currentStep'], 'Number');
      if (data.hasOwnProperty('percentDone'))
        obj.percentDone = ApiClient.convertToType(data['percentDone'], 'Number');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('serialNumber'))
        obj.serialNumber = ApiClient.convertToType(data['serialNumber'], 'Number');
      if (data.hasOwnProperty('createdWhen'))
        obj.createdWhen = ApiClient.convertToType(data['createdWhen'], 'Number');
      if (data.hasOwnProperty('lastUpdated'))
        obj.lastUpdated = ApiClient.convertToType(data['lastUpdated'], 'Number');
      if (data.hasOwnProperty('simpleMessage'))
        obj.simpleMessage = ApiClient.convertToType(data['simpleMessage'], 'String');
      if (data.hasOwnProperty('numRows'))
        obj.numRows = ApiClient.convertToType(data['numRows'], 'Number');
      if (data.hasOwnProperty('numColumns'))
        obj.numColumns = ApiClient.convertToType(data['numColumns'], 'Number');
      if (data.hasOwnProperty('fail'))
        obj.fail = ApiClient.convertToType(data['fail'], 'Boolean');
      if (data.hasOwnProperty('numberOfSteps'))
        obj.numberOfSteps = ApiClient.convertToType(data['numberOfSteps'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} snapshotId
 */
UploadMonitor.prototype.snapshotId = undefined;

/**
 * @member {Boolean} available
 */
UploadMonitor.prototype.available = undefined;

/**
 * @member {Number} currentStep
 */
UploadMonitor.prototype.currentStep = undefined;

/**
 * @member {Number} percentDone
 */
UploadMonitor.prototype.percentDone = undefined;

/**
 * @member {String} message
 */
UploadMonitor.prototype.message = undefined;

/**
 * @member {Number} serialNumber
 */
UploadMonitor.prototype.serialNumber = undefined;

/**
 * @member {Number} createdWhen
 */
UploadMonitor.prototype.createdWhen = undefined;

/**
 * @member {Number} lastUpdated
 */
UploadMonitor.prototype.lastUpdated = undefined;

/**
 * @member {String} simpleMessage
 */
UploadMonitor.prototype.simpleMessage = undefined;

/**
 * @member {Number} numRows
 */
UploadMonitor.prototype.numRows = undefined;

/**
 * @member {Number} numColumns
 */
UploadMonitor.prototype.numColumns = undefined;

/**
 * @member {Boolean} fail
 */
UploadMonitor.prototype.fail = undefined;

/**
 * @member {Number} numberOfSteps
 */
UploadMonitor.prototype.numberOfSteps = undefined;

